import { FC } from 'react';
import PersonalGptHandler from '../Components/PersonalGpt/PersonalGptHandler';

export const PagePersonalGpt: FC = () => {
    return <PersonalGptHandler />;
};
